import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';
import type { IUpdateTicketStatusRequest } from './update-ticket-status-request';

export async function updateTicketStatusApi(
  id: number,
  body: IUpdateTicketStatusRequest,
): Promise<IValidatedResponse<ITicketResponse>> {
  return putRequest<ITicketResponse>({
    path: `/sys/ticket/${id}/status`,
    body,
    schema: ticketResponseSchema,
  });
}
